import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Layout } from 'components/layouts';
import InvestorProfile from 'common/components/rip/InvestorProfile';
import FormButtons from '../FormButtons';
import Title from '../Title';
import profileProvider from './profileProvider';
import { GridLayout } from '../form/layout';

const ResultInner = ({
    rip: {
        id,
        civility,
        firstName,
        lastName,
        partnerCivility,
        partnerLastName,
        partnerFirstName,
    },
    target,
    navigate,
    investorProfile,
    next: { path, label },
}) => {
    const handleSubmit = (event) => {
        event.preventDefault();
        navigate(path);
    };
    const renderProfiles = () => {
        // Cas client&partner (objet avec 2 profils)
        if ('object' === typeof investorProfile && investorProfile !== null) {
            return (
                <Fragment>
                    <GridLayout>

                        {Object.entries(investorProfile).map(([key, profile]) => {
                            const isClient = 'client' === key;
                            const displayName = isClient
                                ? `${civility} ${firstName} ${lastName}`
                                : `${partnerCivility} ${partnerFirstName} ${partnerLastName}`;

                            return (
                                <div key={key} style={{ padding: '50px' }}>
                                    <Title>
                                        <b>Le profil d&apos;investisseur de {displayName}</b>
                                    </Title>
                                    {'declined' === profile ? (
                                        <p>
                                            Questionnaire de risque non renseigné, profil non calculé.
                                        </p>
                                    ) : (
                                        <InvestorProfile
                                            investorProfile={profile}
                                            noChart
                                            title={`Profil de ${key}`}
                                        />
                                    )}
                                </div>
                            );
                        })}

                    </GridLayout>

                </Fragment>
            );
        }

        // Cas classique (string)
        return (
            <div className="container">
                <Title>
                    <b>Le profil d&apos;investisseur</b>
                </Title>
                <InvestorProfile investorProfile={investorProfile} noChart />
            </div>
        );
    };

    return (
        <Layout hasFooter className="simulation-form simulation-overview">
            <form onSubmit={handleSubmit} id="main-form">
                <div className="simulation-form-inner">
                    {renderProfiles()}
                </div>
                <FormButtons
                    list={null}
                    back={`/rip/${id}/investorProfile/${target}`}
                    nextButtonContent={label}
                />
            </form>
        </Layout>
    );
};

ResultInner.propTypes = {
    rip: PropTypes.shape({
        id: PropTypes.string,
        civility: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        partnerCivility: PropTypes.string,
        partnerLastName: PropTypes.string,
        partnerFirstName: PropTypes.string,
    }).isRequired,
    target: PropTypes.string.isRequired,
    investorProfile: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]).isRequired,
    navigate: PropTypes.func,
    next: PropTypes.shape({
        path: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    }).isRequired,
};

const Result = profileProvider(ResultInner);

export default Result;
